import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=338ffe49&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=338ffe49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ffe49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338ffe49')) {
      api.createRecord('338ffe49', component.options)
    } else {
      api.reload('338ffe49', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=338ffe49&scoped=true&", function () {
      api.rerender('338ffe49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2alYqh2EsGcF8/JS/comp/PopupBox.vue"
export default component.exports